import React from "react";
import { Grid, Typography } from "@mui/material";
import DateInput from "../../../components/DateInput";

/** 仕入売上振替確認　集計日付入力フォーム */
export default function SalesPurchaseTransferTotalDateForm({totalDate, changeTotalDate}) {

  return (
    <Grid container alignItems="center" spacing={1} mb={1}>
      <Grid item xs textAlign="right">
        <Typography>対象日 : </Typography>
      </Grid>
      <Grid item xs='auto'>
        <DateInput
          value={totalDate}
          setValue={changeTotalDate}
        />
      </Grid>
    </Grid>
  )  
}